<template>
  <select class="form-control" :required="true" v-model="selected" @change="la_schimb">
   <option v-for="option in options" v-bind:key="option[0]" v-bind:value="option[0]">{{ option[1] }}</option>
  </select>
</template>

<script>
export default {
    name: 'FSelectSantier',
    data () {
        return {
        selected: "SNimic",
        }
    },
    props: ["options"],
    methods:{
        la_schimb: function(){
            //this.$emit('fselect', [this.selected,])
        }
           
    },
    mounted(){
        //this.$emit('fselect', [this.selected,])
    }
    

}
</script>
